var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "chat-distribution-by-user-chart",
      class: { fullscreen: _vm.fullScreen },
    },
    [
      _c("div", { staticClass: "toolbar" }, [
        _c("div", { staticClass: "left" }, [
          _c(
            "div",
            { staticClass: "buttons" },
            [
              _c(
                "IconButton",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { content: _vm.$t("report.chartView") },
                      expression: "{ content: $t('report.chartView') }",
                    },
                  ],
                  attrs: {
                    classNames: _vm.tableMode ? "" : "selected",
                    onClick: function () {
                      return (_vm.tableMode = false)
                    },
                  },
                },
                [_c("md-icon", [_vm._v("insights")])],
                1
              ),
              _vm._v(" "),
              _c(
                "IconButton",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { content: _vm.$t("report.tableView") },
                      expression: "{ content: $t('report.tableView') }",
                    },
                  ],
                  attrs: {
                    classNames: _vm.tableMode ? "selected" : "",
                    onClick: function () {
                      return (_vm.tableMode = true)
                    },
                  },
                },
                [_c("md-icon", [_vm._v("table_view")])],
                1
              ),
              _vm._v(" "),
              _c(
                "IconButton",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { content: _vm.$t("report.download") },
                      expression: "{ content: $t('report.download') }",
                    },
                  ],
                  attrs: { onClick: _vm.exportToExcel },
                },
                [_c("md-icon", [_vm._v("download")])],
                1
              ),
              _vm._v(" "),
              _c(
                "IconButton",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { content: _vm.$t("report.fullScreen") },
                      expression: "{ content: $t('report.fullScreen') }",
                    },
                  ],
                  attrs: { onClick: _vm.switchToFullScreenMode },
                },
                [
                  !_vm.fullScreen
                    ? _c("md-icon", [_vm._v("fullscreen")])
                    : _c("md-icon", [_vm._v("fullscreen_exit")]),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "chart-wrapper" },
        [
          !_vm.tableMode
            ? _c("DoubleBarChart", {
                attrs: {
                  title: _vm.$t("report.chatDistByUsers"),
                  xAxisData: _vm.getXAxisData(),
                  yAxisData: _vm.getYAxisData(),
                  series: _vm.getSeries(),
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.tableMode
            ? _c("TableView", {
                attrs: { cols: _vm.getCols(), rows: _vm.getRows() },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "stats" },
        [
          _c("StatCard", {
            attrs: {
              title: _vm.$t("report.mostChatRecipients"),
              value: _vm.getStats().MaxAgent,
            },
          }),
          _vm._v(" "),
          _c("StatCard", {
            attrs: {
              title: _vm.$t("report.leastChatReceiver"),
              value: _vm.getStats().MinAgent,
            },
          }),
          _vm._v(" "),
          _c("StatCard", {
            attrs: {
              title: _vm.$t("report.averageChat"),
              value: _vm.formatStat(_vm.getStats().AvgAgent).value,
              unit: _vm.formatStat(_vm.getStats().AvgAgent).unit,
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }